import { render, staticRenderFns } from "./OrganizersSelect.vue?vue&type=template&id=20ae078c"
import script from "./OrganizersSelect.vue?vue&type=script&lang=js"
export * from "./OrganizersSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports